import { v4 as uuidV4 } from 'uuid';
import { DonorProfileFormValues, OrganSpecificDonorProfileFormValues, SharedDonorProfileFormValues } from './types';

export const getSharedDonorProfileDefaultValues = (): SharedDonorProfileFormValues => ({
  neuroStatus: null,
  vasopressors: null,
  vasopressorsDetails: null,
  sustainedHypotension: null,
  sustainedHypotensionDetails: null,
  aboType: null,
  positiveSerologies: null,
  donorAge: null,
  donorWeight: null,
  donorHeight: null,
  donorBmi: null,
  donorGender: null,
  causeOfDeath: null,
  reasonForUnallocated: null,
});

/** Also the blank slate a re-added organ is reset to. */
export const getOrganSpecificDonorProfileDefaultValues = (): OrganSpecificDonorProfileFormValues => ({
  matchId: null,
  ocsMatchRunCenters: null,
  tbiliResult1: null,
  tbiliResult2: null,
  sgotAstResult1: null,
  sgotAstResult2: null,
  sgptAltResult1: null,
  sgptAltResult2: null,
  localSurgeonToProcure: null,
  localSurgeonToProcureDetails: null,
  ctScan: null,
  ctScanDetails: null,
  ctScanLink: [{ id: uuidV4(), url: '', description: '', isNew: true }],
  ctScanDocuments: [],
  sedation: null,
  pfRatio: null,
  fluidBalance24hr: null,
  cultureSensitivities: null,
});

export const getDonorProfileDefaultValues = (): DonorProfileFormValues => ({
  ...getSharedDonorProfileDefaultValues(),
  ...getOrganSpecificDonorProfileDefaultValues(),
});
